import { Routes, Route } from 'react-router-dom'
import ScratchCard from './scratch-card-redemption/Page'
import ScratchCardDetail from './scratch-card-redemption/detail/Page'
import AppleLuckyDraw from './apple-products-lucky-draw/Page'
import AppleLuckyDrawDetail from './apple-products-lucky-draw/detail/Page'

const Page = () => {
  return (
    <Routes>
      <Route path='/scratch-card-redemption' element={<ScratchCard />} />
      <Route path='/scratch-card-redemption/:id' element={<ScratchCardDetail />} />
      <Route path='/apple-products-lucky-draw' element={<AppleLuckyDraw />} />
      <Route path='/apple-products-lucky-draw/:id' element={<AppleLuckyDrawDetail />} />
    </Routes>
  )
}

export default Page
